import { render } from "./App.vue?vue&type=template&id=075a7c7b&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=075a7c7b&scoped=true&lang=css"

import exportComponent from "/Users/tatana/Documents/Chext/dev/neatify_frnt-bck/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075a7c7b"]])

export default __exports__